import "./UpdateDeal.css";
import React, { Fragment, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FormControl,
  MenuItem,
  Select,
  Avatar,
  TextField,
  ButtonGroup,
  Button,
  RadioGroup,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { ToastContainer } from "react-toastify";
import LeadForm from "../../components/LeadForm/LeadForm";
import Modal from "@mui/material/Modal";

// MUI Components Start
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/CloudDownload";
import FileIcon from "@mui/icons-material/InsertDriveFile";
import Autocomplete from "@mui/material/Autocomplete";
import { DateTimePicker, LocalizationProvider } from "@mui/lab";
// MUI Components End

// Firebase Start
import {
  getDownloadURL,
  getMetadata,
  listAll,
  uploadBytes,
} from "firebase/storage";
import { getStorage } from "firebase/storage";
import { ref } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { doc, getDoc, query, setDoc, Timestamp } from "firebase/firestore";
// Firebase End

// Form Validate imports Start
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { LogVisitorSchema } from "../../schemas";
// Form Validate imports End

// Npm Packages Start
import { Dropzone, FileItem, FullScreenPreview } from "@dropzone-ui/react";
import uniqid from "uniqid";
// Npm Packages End

// Controllers Start
import GetSingleDeal from "../../controllers/Enquiries/GetSingleDeal";
import UpdateSingleDeal from "../../controllers/Enquiries/UpdateSingleDeal";
import GetAllAgents from "../../controllers/agents/GetAllAgents";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import GetAllLeads from "../../controllers/leads/GetAllLeads";
import GetProperty from "../../controllers/properties/getProperty";
import CreateSingleLead from "../../controllers/leads/CreateSingleLead";
import GetAdmin from "../../controllers/Enquiries/GetAdmin";
import AddLogVisitors from "../../controllers/properties/AddLogVisitors";
import GetLogVisitors from "../../controllers/properties/GetLogVisitors";
import getSettings from "../../controllers/settings/getSettings";
// Controllers End

// Common Components Start
import RadioButton from "./../../components/Common/RadioButton/RadioButton";
import TransactionList from "../../components/Common/Enquiry/TransactionList/TransactionList";
// Common Components End

// Functions Start
import { stringAvatar } from "../../helpers/stringAvatar";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import FormatPriceNumeral from "../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../helpers/FormatPriceVerbal";
import { MultipleQueryTypesense } from "../../Typesense";
import addNotification from "../../controllers/notifications/store_notification";
import { db } from "../../firebase";
import getJsUTC from "../../helpers/getJsUTC";
import { getEmailFromFirestore } from "../../controllers/notifications/get_tokens";
// Functions End

// Form Validate schema Start
const schema = yup.object().shape({
  // interest: yup.bool().oneOf([true], "Interest is required").nullable(),
  interest: yup.string().required("Interest is required").default(""),
  dealPrice: yup.string().required("Deal price is required"),
  lead: yup.string().required("Client is required"),

  property: yup.string().required("Property is required"),
  agent: yup.string().required("Agent is required"),
  paymentCycle: yup.string().default(""),
  name: yup.string().min(3).required("Name is required"),
  phone: yup.string(),
  email: yup.string(),
  cnic: yup.string(),
});
// Form Validate schema End

let DealId;
let holdLead = "";
const generateDealId = () => (DealId = uniqid() + uniqid() + uniqid());

// Custom Style If There Are No Log Visits Data In Update Deal Form Log Visits DataGrid Table Start
function CustomNoRowsOverlay() {
  return <div className="property-log-visits-custom-nothing"></div>;
}
// Custom Style If There Are No Log Visits Data In Update Deal Form Log Visits DataGrid Table End

const UpdateDeal = () => {
  const Navigate = useNavigate();
  const Location = useLocation();

  const [isDisabled, setIsDisabled] = useState(false);
  const [leads, setLeads] = useState();
  const [admin, setAdmin] = useState({});

  const [agents, setAgents] = useState(null);
  const [properties, setProperties] = useState(null);
  const [property, setProperty] = useState(null);
  const [Refresh, setRefresh] = useState(true);
  const [showClient, setShowClient] = useState(true);
  const [IsGettingUploadedFiles, setIsGettingUploadedFiles] = useState(true);

  const [ServerFiles, setServerFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [imageSrc, setImageSrc] = useState(undefined);
  const updateFiles = (incommingFiles) => {
    setFiles(incommingFiles);
  };
  const onDelete = (id) => {
    setFiles(files.filter((x) => x.id !== id));
  };
  const handleSee = (imageSource) => {
    setImageSrc(imageSource);
  };
  const handleClean = (files) => {};
  const updateNewFilesStatus = () => {
    let a = [...files];
    a = a.map((file) => {
      return { ...file, uploadStatus: file.uploadStatus || "uploading" };
    });
    setFiles(a);
  };
  const markAsUploaded = (__ID) => {
    let a = [...files];
    a = a.map((file) => {
      return {
        ...file,
        uploadStatus: file.id === __ID ? "success" : file.uploadStatus,
      };
    });
    setFiles([...a]);
  };
  const uploadImages = async () => {
    for (let index = 0; index < files.length; index++) {
      if (
        files[index].uploadStatus &&
        files[index].uploadStatus !== "uploading"
      )
        continue;
      const { file, id, valid } = files[index];
      const { type } = file;
      const __ext = type.split("/").pop();
      const __path = ref(getStorage(), `deals/${DealId}/${id}.${__ext}`);
      await uploadBytes(__path, file).then(async (snapshot) => {
        markAsUploaded();
      });
    }
    uploadFinish();
  };
  const uploadStart = () => {
    setIsUploading(true);
    updateNewFilesStatus();
    uploadImages();
  };
  const uploadFinish = () => {
    setTimeout(() => {
      setIsUploading(false);
    }, 2000);
  };
  useEffect(() => {
    if (files.length === 0) return;
    if (isUploading) return;
    uploadStart();
  }, [files]);

  const downloadFile = (url) => {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      link.setAttribute("href", url);
      link.setAttribute("target", "_blank");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const [UpdateEnquiryData, setUpdateEnquiryData] = useState(null);

  const [agent, setAgent] = useState();
  const [area, setArea] = useState();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [CNIC, setCNIC] = useState("");
  const [address, setAddress] = useState("");
  const [logVisitors, setLogVisitors] = useState(null);

  // Form Validate const Start
  const optionsForm = { resolver: yupResolver(schema) };
  const { register, handleSubmit, setValue, setError, watch, formState } =
    useForm(optionsForm);
  const { errors } = formState;
  // const {
  //   register,
  //   handleSubmit,
  //   watch,
  //   setValue,
  //   formState: { errors },
  // } = useForm();
  // Form Validate const End

  const { reset } = useForm({
    resolver: yupResolver(LogVisitorSchema),
  });
  // Form Validate const End

  const [DealData, setDealData] = useState(null);
  const [propertyId, setPropertyId] = useState("");

  useEffect(() => {
    const fetchdata = async () => {
      DealId = Location.pathname.split("/").pop();
      let res = await GetSingleDeal(DealId);
      const trans = res.transactions;
      delete trans.transactions;
      res = { ...res, comments: res.comments.filter((c) => c !== "") };
      setDealData(res);
      setTransactions([...trans]);
      // setValue("lead", DealData.name);
      /** List all in react hook form, so they can appear in form */
      Object.entries(res).forEach((e) => {
        // if (!["name"].includes(e[0]))
        setValue(e[0], e[1]);
        if (e[0] === "property") {
          setPropertyId(e[1]);
        }
      });

      /** Get files from server */
      await listAll(ref(getStorage(), `deals/${DealId}`)).then(
        async ({ items }) => {
          let arr = [];
          for (let index = 0; index < items.length; index++) {
            const item = items[index];
            const metadata = await getMetadata(item);
            const url = await getDownloadURL(item);
            arr.push({ ...metadata, url });
          }
          setServerFiles([...arr]);
          setIsGettingUploadedFiles(false);
        }
      );
    };
    fetchdata();
  }, []);

  //getting property details
  useEffect(() => {
    const fetchproperty = async () => {
      const Property = await GetProperty(watch("property"));
      setProperty(Property);
    };
    //watch("property") returns id of the property in the deal
    if (watch("property")) {
      fetchproperty();
    }
  }, [watch, DealData, propertyId]);

  // Leads useEffect Start
  useEffect(() => {
    async function fetchData() {
      const leadsData = (await GetAllLeads("*", "newest", "*", 100)).leads;
      setLeads(leadsData);
    }
    fetchData();
  }, [Refresh]);
  // Leads useEffect End

  // Admin useEffect Start
  useEffect(() => {
    async function fetchData() {
      const adminData = await GetAdmin();
      setAdmin(adminData);
    }
    fetchData();
  }, []);
  // Admin useEffect End

  // Agents useEffect Start
  useEffect(() => {
    async function fetchData() {
      let agentsData = (await GetAllAgents("*", "newest", "*", 100)).agents;

      const { uid } = getAuth().currentUser;

      let adminData = await GetAdmin();
      adminData = { ...adminData, id: adminData.uid };

      agentsData.unshift(adminData);

      setAgents(agentsData);
    }
    fetchData();
  }, [admin]);
  // Agents useEffect End

  const [propertyInputValue, setPropertyInputValue] = useState("");
  useEffect(() => {
    async function fetchPropertiesTypsenseWithSearch() {
      let properties = (
        await MultipleQueryTypesense({
          searches: [
            {
              collection: "properties",
              q: propertyInputValue,
              page: 1,
              per_page: 10,
              query_by: "propertyTitle",
              filter_by: `is_deleted:=false && status:=shared && sharedParties:=[${getLocalStorageItem(
                "bid"
              )}]  ${
                watch("interest") === "buy"
                  ? ""
                  : watch("interest") === "sale"
                  ? "&& sellingPrice :> 0"
                  : "&& rentalPrice :> 0"
              } && propertyStatus:=available`,
            },
            {
              filter_by: `is_deleted:=false &&bid:=${getLocalStorageItem(
                "bid"
              )}   ${
                watch("interest") === "buy"
                  ? ""
                  : watch("interest") === "sale"
                  ? "&& sellingPrice :> 0"
                  : "&& rentalPrice :> 0"
              } && propertyStatus:=available`,
              collection: "properties",
              page: 1,
              per_page: 10,
              query_by: "propertyTitle",
              q: propertyInputValue,
            },
          ],
        })
      ).map(({ document }) => document);
      setProperties([...properties]);
    }

    fetchPropertiesTypsenseWithSearch();
  }, [propertyInputValue, watch("interest")]);

  /** Transactions */
  const [Amount, setAmount] = useState();
  const [Comments, setComments] = useState("");
  const [PaymentType, setPaymentType] = useState("");
  const [Transactions, setTransactions] = useState([]);
  const [FormVisible, setFormVisible] = useState(false);
  // const [FormVisible, setFormVisible] = useState(false);
  const [LeadFormVisible, setLeadFormVisible] = useState(false);
  const [DisableLeadForm, setDisableLeadForm] = useState(false);
  const [newButtonStyle, setNewButtonStyle] = useState(false);
  const [existingButtonStyle, setExistingButtonStyle] = useState(true);
  const [TransactionToEditIndex, setTransactionToEditIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen("add");
  const handleRefresh = () => {
    setRefresh(!Refresh);
  };
  const disableInputAndToggleForm = () => {
    setShowClient(false);
    setDisableLeadForm(true);
    setLeadFormVisible(true);
    setExistingButtonStyle(false);
    setNewButtonStyle(true);
    holdLead = watch("lead");
    setValue("lead", "null");
    setValue("name", name);
    setValue("phone", phone);
    setValue("email", email);
    setValue("cnic", CNIC);
    setValue("company", company);
    setValue("address", address);
  };

  const enableInputAndHideForm = () => {
    setShowClient(true);
    setDisableLeadForm(false);
    setLeadFormVisible(false);
    setNewButtonStyle(false);
    setExistingButtonStyle(true);
    setValue("lead", holdLead);
    setLead(holdLead);
    setValue("name", "null");
    setValue("phone", "null");
    setValue("email", "null");
    setValue("cnic", "null");
    setValue("company", "null");
    setValue("address", "null");
  };

  /** Initially set the values of new lead form, so it doesn't throws error on submit */
  useEffect(() => {
    holdLead = watch("lead");

    setValue("lead", holdLead);

    setShowClient(true);
    setDisableLeadForm(false);
    setLeadFormVisible(false);
    setLead(holdLead);
    setValue("name", "null");
    setValue("phone", "null");
    setValue("email", "null");
    setValue("cnic", "null");
    setValue("company", "null");
    setValue("address", "null");
  }, []);

  const toggleFormVisible = () => setFormVisible(!FormVisible);
  const clearTransactionForm = () => {
    setAmount("");
    setComments("");
    setPaymentType("");
    setTransactionToEditIndex(null);
  };
  const closeTransactionForm = () => {
    clearTransactionForm();
    toggleFormVisible();
  };
  const setFormForUpdate = (index) => {
    const { amount, comments, paymentType } = Transactions[index];
    setAmount(amount);
    setComments(comments);
    setPaymentType(paymentType);
    setTransactionToEditIndex(index);
    setFormVisible(true);
  };
  const addTransaction = () => {
    const o = {
      amount: Amount,
      comments: Comments,
      paymentType: PaymentType,
    };
    setTransactions([...Transactions, o]);
    closeTransactionForm();
  };
  const updateTransaction = () => {
    const o = {
      amount: Amount,
      comments: Comments,
      paymentType: PaymentType,
    };
    let e = [...Transactions];
    e[TransactionToEditIndex] = o;
    setTransactions([...e]);
    closeTransactionForm();
  };
  const removeTransaction = (index) => {
    setTransactions([...Transactions.filter((e, i) => i !== index)]);
  };

  const submitForm = async () => {
    setIsDisabled(true);
    let e = watch();

    const leadData = {
      name: e.name,
      phone: e.phone,
      email: e.email,
      company: e.company,
      cnic: e.cnic,
      address: e.address,
    };
    const finalLeadObject = HelperForMetaData({ ...leadData });
    let leadId;
    leadId = existingButtonStyle ? "" : await CreateSingleLead(finalLeadObject);
    if (leadId === null) {
      setValue("cnic", "");
      setIsDisabled(false);
      setError("cnic", {
        type: "required",
        message: "Duplicate record found! Can't create new lead!",
      });
      return;
    }
    leadId = leadId === "" ? e.lead : leadId;

    /** Remove lead fields if existed */
    if (!existingButtonStyle) {
      delete e.name;
      delete e.phone;
      delete e.email;
      delete e.company;
      delete e.cnic;
      delete e.address;
    }

    /** Add comments in array */
    e.comments = [...e.comments];
    ![undefined, "", null].includes(area) && e.comments.push(area);
    e = { ...e, transactions: [...Transactions], lead: leadId };
    e = { ...HelperForMetaData(e) };
    delete e.createdAt;
    delete e.createdBy;

    e.transactions = e.transactions.map((t) => {
      const m = HelperForMetaData({});
      if (t.createdBy) {
        delete m.createdAt;
        delete m.createdBy;
      }
      return { ...t, ...m };
    });

    if (e.currentstatus === "won") {
      let uid = getAuth().currentUser.uid;
      let userData = await getEmailFromFirestore(uid);
      const propRef = doc(db, "properties", e.property);
      const propertySnap = await getDoc(propRef);
      const data = propertySnap.data();
      const title =
        userData.name + " Won the Deal for your " + data.propertySubType + "!";
      const description =
        userData.name + " Won the Deal for your " + data.propertySubType + "!";
      const notification_type = "Deal is Won";
      const notification_link =
        "https://app.landbook.pk" +
        "/user/properties/inventory/details/" +
        e.property;
      const record_id = e.id;
      const receiver_id = e.property;
      const is_seen = false;
      const is_deleted = false;
      const image = "";

      try {
        await addNotification(
          title,
          description,
          notification_type,
          image,
          notification_link,
          record_id,
          receiver_id,
          is_seen,
          is_deleted
        );
      } catch (ex) {}

      try {
        const propRef = query(doc(db, "properties", e.property));
        const propertySnap = await getDoc(propRef);
        await setDoc(doc(db, "properties", e.property), {
          ...propertySnap.data(),
          propertyStatus: propertySnap.rentalPrice === 0 ? "Rent Out" : "Sold",
          wonAt: Timestamp.fromDate(new Date(getJsUTC())),
        });
      } catch (ex) {
        console.log(ex);
      }
    } else {
      try {
        const propRef = query(doc(db, "properties", e.property));
        const propertySnap = await getDoc(propRef);
        await setDoc(doc(db, "properties", e.property), {
          ...propertySnap.data(),
          propertyStatus: "available",
        });
      } catch (ex) {
        console.log(ex);
      }
    }
    await UpdateSingleDeal(DealId, e);

    Navigate("/user/deals");
    setIsDisabled(false);
  };

  const location = useLocation();
  const dealID = location.pathname.split("/").pop();
  // Log Visitors useEffect Start
  useEffect(() => {
    async function fetchData() {
      let visitors = await GetLogVisitors(propertyId);

      setLogVisitors(visitors);
    }
    fetchData();
  }, [dealID, Refresh, propertyId]);
  // Log Visitors useEffect End

  // Modal Hide on form submit Start
  function handleCloseModal() {
    document
      .getElementById("exampleModalLong")
      .classList.remove("show", "d-block");
    document
      .querySelectorAll(".modal-backdrop")
      .forEach((el) => el.classList.remove("modal-backdrop"));
  }
  // Modal Hide on form submit

  let [lead, setLead] = useState("");
  let [status, setStatus] = useState("interested");
  let [visitorDateTime, setVisitorDateTime] = useState(new Date());
  const [description, setDescription] = useState("");
  const [LeadError, setLeadError] = useState("");
  const [StatusError, setStatusError] = useState("");
  const [DateTimeError, setDateTimeError] = useState("");

  // SubmitForm Start
  const submitVisitsForm = async (e) => {
    e.preventDefault();

    const dateTime = Timestamp.fromDate(visitorDateTime);
    let l = lead;
    if (!l) {
      l = leads.filter((lead) => lead.id === watch("lead")).pop();
    }
    const { id } = l;
    let visitsData = {
      propertyId: propertyId,
      bid: getLocalStorageItem("bid"),
      lead: id,
      leadName: l.name,
      status,
      description,
      deal: dealID,
    };

    visitsData = { ...visitsData, dateTime };
    let uid = getAuth().currentUser.uid;
    let userData = await getEmailFromFirestore(uid);
    const propRef = doc(db, "properties", watch("property"));
    const propertySnap = await getDoc(propRef);
    const data = propertySnap.data();
    const title =
      userData.name +
      " gives a visit to " +
      l.name +
      " at a " +
      data.propertySubType +
      ", and that Person was '" +
      status +
      "' in that.";
    const descriptionNotification =
      userData.name +
      " gives a visit to " +
      l.name +
      " at a " +
      data.propertySubType +
      ", and that Person was '" +
      status +
      "' in that.";
    const notification_type = "Log Visitor";
    const notification_link =
      "https://app.landbook.pk" +
      "/user/properties/inventory/details/" +
      watch("property");
    const record_id = dealID;
    const receiver_id = watch("property");
    const is_seen = false;
    const is_deleted = false;
    const image = "";
    await addNotification(
      title,
      descriptionNotification,
      notification_type,
      image,
      notification_link,
      record_id,
      receiver_id,
      is_seen,
      is_deleted
    );

    setIsDisabled(true);
    const visitor = await AddLogVisitors(visitsData);

    if (visitor) {
      setIsDisabled(false);
      setRefresh(!Refresh);
    } else setIsDisabled(false);

    handleCloseModal();
  };
  // SubmitForm End

  // Currency Settings UseEffect Start
  const [CurrencySettings, setCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setCurrencySettings(settings);
    }
    fetchData();
  }, []);
  // Currency Settings UseEffect End

  // UI States Start
  const [TransactionTab, setTransactionTab] = useState(true);
  const [LogVisitsTab, setLogVisitsTab] = useState(false);
  const [FilesTab, setFilesTab] = useState(false);
  const [LogVisitorModal, setLogVisitorModal] = useState(false);
  // UI States End
  return (
    <Fragment>
      <div className="global-body-container">
        <div className="d-flex align-items-start">
          <div className="mr-4 d-lg-block">
            <Link
              to="/user/deals"
              className="btn light btn-primary btn-sm mb-4"
            >
              <i className="la la-angle-left"></i> Back
            </Link>
          </div>
          <div className="mr-auto d-lg-block">
            {DealData && property && (
              <div className="boxTitle">{property?.propertyTitle}</div>
            )}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-6 col-sm-12 col-lg-6">
            <form
              className="modal-body"
              onSubmit={handleSubmit(submitForm)}
              noValidate
            >
              <Fragment>
                <div className="col-12 col-xl-12 col-xxl-12 col-lg-12 col-md-12 pt-4 m-auto">
                  <div className="card bg-box">
                    <div className="card-body">
                      <div className="form-row">
                        <div className="form-group col-12">
                          <div className="row">
                            <div className="col-7 propertyLeadWrapper">
                              {DealData && property && (
                                <Fragment>
                                  <div className="boxTitle">
                                    {property?.propertyTitle}
                                  </div>
                                  <div className="updateLead">
                                    {leads &&
                                      watch("lead") &&
                                      leads
                                        .filter((l) => l.id === watch("lead"))
                                        .pop()?.name}
                                  </div>
                                </Fragment>
                              )}
                            </div>
                            {DealData && (
                              <div className="col-5 d-flex justify-content-end">
                                <FormControl>
                                  <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                  >
                                    <FormControl fullWidth>
                                      {watch("currentstatus") !== undefined && (
                                        <ButtonGroup
                                          variant="outlined"
                                          aria-label="outlined button group"
                                        >
                                          <Button
                                            className={
                                              watch("currentstatus") === "open"
                                                ? "customDealBtnSelected"
                                                : "customDealBtn"
                                            }
                                            onClick={() =>
                                              setValue("currentstatus", "open")
                                            }
                                          >
                                            Open
                                          </Button>
                                          <Button
                                            className={
                                              watch("currentstatus") === "won"
                                                ? "customDealBtnSelected"
                                                : "customDealBtn"
                                            }
                                            onClick={() =>
                                              setValue("currentstatus", "won")
                                            }
                                          >
                                            Won
                                          </Button>
                                          <Button
                                            className={
                                              watch("currentstatus") === "lost"
                                                ? "customDealBtnSelected"
                                                : "customDealBtn"
                                            }
                                            onClick={() =>
                                              setValue("currentstatus", "lost")
                                            }
                                          >
                                            Lost
                                          </Button>
                                        </ButtonGroup>
                                      )}
                                    </FormControl>
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            )}
                          </div>
                        </div>

                        {DealData && (
                          <div className="col-12">
                            <div className="form-group col-12">
                              <FormControl fullWidth>
                                <div className="row">
                                  <div className="col-4">
                                    <RadioButton
                                      label={
                                        <label className="myLbl2">
                                          Interest{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                      }
                                      status={"Buy"}
                                      type={"radio"}
                                      value="buy"
                                      register={{
                                        ...register("interest", {
                                          required: true,
                                        }),
                                      }}
                                      isDisabled={isDisabled}
                                      checked={watch("interest") === "buy"}
                                    />
                                    <p className="errorMessage mb-0">
                                      {errors.interest?.message}
                                    </p>
                                  </div>
                                  <div className="col-4">
                                    <label> &nbsp; </label>
                                    <RadioButton
                                      className={"radio-style"}
                                      status={"Sale"}
                                      type={"radio"}
                                      value="sale"
                                      register={{
                                        ...register("interest", {
                                          required: true,
                                        }),
                                      }}
                                      isDisabled={isDisabled}
                                      checked={watch("interest") === "sale"}
                                    />
                                  </div>
                                  <div className="col-4">
                                    <label> &nbsp; </label>
                                    <RadioButton
                                      status={"Rent"}
                                      type={"radio"}
                                      value="rent"
                                      register={{
                                        ...register("interest", {
                                          required: true,
                                        }),
                                      }}
                                      isDisabled={isDisabled}
                                      checked={watch("interest") === "rent"}
                                    />
                                  </div>
                                </div>
                              </FormControl>
                            </div>

                            <Fragment>
                              <div className="form-group col-12 mb-0">
                                <FormControl fullWidth>
                                  <div className="row">
                                    <div className="col-12">
                                      <div>
                                        <div className="add-new-client-btn-container">
                                          <label className="myLbl">
                                            Client{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <p
                                            className="add-new-client"
                                            onClick={handleOpen}
                                          >
                                            Add New Client
                                          </p>
                                        </div>
                                        <FormControl
                                          fullWidth
                                          className="whiteBackground"
                                        >
                                          {leads &&
                                            watch("lead") !== undefined && (
                                              <Autocomplete
                                                id="tags-outlined"
                                                options={leads}
                                                Agent
                                                value={leads
                                                  .filter(
                                                    (a) =>
                                                      a.id === watch("lead")
                                                  )
                                                  .pop()}
                                                onChange={(event, value) =>
                                                  setValue("lead", value.id)
                                                }
                                                getOptionLabel={(option) =>
                                                  option.name
                                                }
                                                renderOption={(
                                                  props,
                                                  option
                                                ) => (
                                                  <MenuItem
                                                    {...props}
                                                    id={option.id}
                                                  >
                                                    {
                                                      <Card
                                                        sx={{
                                                          display: "flex",
                                                        }}
                                                        elevation={0}
                                                        // className="agentInputCard"
                                                        className="update-deal-client-dropdown"
                                                      >
                                                        <Avatar
                                                          // className="ml-1 mt-1 agentInputAvatar"
                                                          className="update-deal-client-dropdown-avatar"
                                                          {...stringAvatar(
                                                            option.name
                                                          )}
                                                        />

                                                        <Typography
                                                          component="div"
                                                          variant="p"
                                                          // className="agentInputName"
                                                          className="update-deal-client-dropdown-name"
                                                        >
                                                          {option.name}
                                                        </Typography>
                                                      </Card>
                                                    }
                                                  </MenuItem>
                                                )}
                                                renderInput={(params) => {
                                                  return (
                                                    <TextField
                                                      {...params}
                                                      size="small"
                                                      placeholder="Search Client"
                                                      value={
                                                        DealData &&
                                                        DealData.name
                                                      }
                                                    />
                                                  );
                                                }}
                                              />
                                            )}
                                        </FormControl>
                                      </div>

                                      <p
                                        className={`errorMessage m-0 ${
                                          DisableLeadForm
                                            ? "d-none"
                                            : "d-inline-flex"
                                        }`}
                                      >
                                        {!watch("lead")
                                          ? errors.lead?.message
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                </FormControl>
                              </div>
                            </Fragment>

                            <div className="form-group col-12 mb-0">
                              <FormControl fullWidth>
                                <div className="row">
                                  <div className="col-8">
                                    <label className="myLbl">
                                      Properties{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <FormControl
                                      fullWidth
                                      className="whiteBackground"
                                    >
                                      {properties &&
                                        watch("property") &&
                                        property && (
                                          <Autocomplete
                                            id="tags-outlined"
                                            options={properties}
                                            Property
                                            getOptionLabel={(option) =>
                                              option.propertyTitle
                                            }
                                            inputValue={propertyInputValue}
                                            onInputChange={(
                                              event,
                                              newInputValue
                                            ) => {
                                              setPropertyInputValue(
                                                newInputValue
                                              );
                                            }}
                                            value={property}
                                            onChange={(event, value) => {
                                              setValue("property", value.id);
                                              setPropertyId(value.id);
                                              setProperty(value);
                                              setValue(
                                                "dealPrice",
                                                watch("interest") === "buy" ||
                                                  watch("interest") === "sale"
                                                  ? value.sellingPrice ||
                                                      value.rentalPrice
                                                  : watch("interest") === "rent"
                                                  ? value.rentalPrice ||
                                                    value.sellingPrice
                                                  : 0
                                              );
                                            }}
                                            renderOption={(props, option) => (
                                              <MenuItem
                                                {...props}
                                                id={option.id}
                                              >
                                                {
                                                  <Card
                                                    sx={{ display: "flex" }}
                                                    elevation={0}
                                                    // className="propertyInputCard"
                                                    className="update-deal-property-dropdown"
                                                  >
                                                    <CardMedia
                                                      component="img"
                                                      // className="propertyInputImage"
                                                      className="update-deal-property-dropdown-avatar"
                                                      image={
                                                        option?.images[0] ??
                                                        "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general_images%2Fimage-avatar.png?alt=media&token=55121c1a-5ee6-4aec-af10-3ca9ebebce1e"
                                                      }
                                                      alt="property"
                                                    />
                                                    <Box
                                                      fullWidth
                                                      sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                      }}
                                                      className="update-deal-property-dropdown-name"
                                                    >
                                                      <Typography
                                                        component="div"
                                                        variant="p"
                                                        className="propertyInputName"
                                                      >
                                                        {option.propertyTitle}
                                                      </Typography>
                                                      <Typography
                                                        variant="subtitle1"
                                                        component="div"
                                                        className="propertyInputPrice"
                                                      >
                                                        {`${
                                                          CurrencySettings?.currency
                                                        } ${
                                                          option?.sellingPrice &&
                                                          CurrencySettings.currencyFormat ===
                                                            "numeral"
                                                            ? FormatPriceNumeral(
                                                                option?.sellingPrice
                                                              )
                                                            : option?.sellingPrice &&
                                                              CurrencySettings.currencyFormat ===
                                                                "verbal"
                                                            ? FormatPriceVerbal(
                                                                option?.sellingPrice
                                                              )
                                                            : option?.rentalPrice &&
                                                              CurrencySettings.currencyFormat ===
                                                                "numeral"
                                                            ? FormatPriceNumeral(
                                                                option?.rentalPrice
                                                              )
                                                            : option?.rentalPrice &&
                                                              CurrencySettings.currencyFormat ===
                                                                "verbal"
                                                            ? FormatPriceVerbal(
                                                                option?.rentalPrice
                                                              )
                                                            : ""
                                                        }`}
                                                      </Typography>
                                                    </Box>
                                                  </Card>
                                                }
                                              </MenuItem>
                                            )}
                                            renderInput={(params) => {
                                              return (
                                                <TextField
                                                  {...params}
                                                  size="small"
                                                  placeholder="Search Property"
                                                />
                                              );
                                            }}
                                          />
                                        )}
                                    </FormControl>
                                    <p className="errorMessage mb-2">
                                      {errors.property?.message}
                                    </p>
                                  </div>
                                  <div className="col-4">
                                    <FormControl fullWidth className="">
                                      <label className="myLbl">
                                        Deal Price{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <TextField
                                        id="outlined-basic"
                                        name="dealPrice"
                                        size="small"
                                        type="number"
                                        {...register("dealPrice")}
                                        onChange={(e) => {
                                          e.target.value > 0
                                            ? setValue(
                                                "dealPrice",
                                                e.target.value
                                              )
                                            : setValue("dealPrice", "");
                                        }}
                                        className="bg-white"
                                        variant="outlined"
                                        disabled={isDisabled}
                                      />

                                      {errors.dealPrice ? (
                                        <p className="errorMessage">
                                          {errors.dealPrice?.message}
                                        </p>
                                      ) : (
                                        <p
                                          style={{
                                            color: "#4B4B4BE5",
                                          }}
                                        >
                                          {watch("dealPrice") > 0 && (
                                            <span>
                                              {CurrencySettings.currency}
                                              {`
                                              ${
                                                watch("dealPrice") &&
                                                watch("dealPrice") > 0
                                                  ? FormatPriceVerbal(
                                                      watch("dealPrice")
                                                    )
                                                  : ""
                                              }
                                            `}
                                            </span>
                                          )}
                                        </p>
                                      )}
                                    </FormControl>
                                  </div>
                                </div>
                              </FormControl>
                            </div>

                            <div className="form-group col-12 mb-2">
                              <FormControl fullWidth>
                                <div className="row">
                                  <div className="col-8">
                                    <label className="myLbl">
                                      Agents{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <FormControl
                                      fullWidth
                                      className="whiteBackground"
                                    >
                                      {agents &&
                                        watch("agent") !== undefined && (
                                          <Autocomplete
                                            id="tags-outlined"
                                            options={agents}
                                            Agent
                                            value={agents
                                              .filter(
                                                (a) => a.id === watch("agent")
                                              )
                                              .pop()}
                                            onChange={(event, value) =>
                                              setValue("agent", value.id)
                                            }
                                            getOptionLabel={(option) =>
                                              option.name
                                            }
                                            renderOption={(props, option) => (
                                              <MenuItem
                                                {...props}
                                                id={option.id}
                                              >
                                                {
                                                  <Card
                                                    sx={{ display: "flex" }}
                                                    style={{
                                                      width: "100%",
                                                    }}
                                                    elevation={0}
                                                    // className="agentInputCard"
                                                    className="update-deal-agent-dropdown"
                                                  >
                                                    <Avatar
                                                      // className="ml-1 mt-1 agentInputAvatar"
                                                      className="update-deal-agent-dropdown-avatar"
                                                      {...stringAvatar(
                                                        option.name
                                                      )}
                                                    />

                                                    <Typography
                                                      component="div"
                                                      variant="p"
                                                      // className="agentInputName"
                                                      className="update-deal-agent-dropdown-name"
                                                    >
                                                      {option.name}
                                                    </Typography>
                                                  </Card>
                                                }
                                              </MenuItem>
                                            )}
                                            renderInput={(params) => {
                                              return (
                                                <TextField
                                                  {...params}
                                                  size="small"
                                                  placeholder="Search Agent"
                                                  value={
                                                    DealData && DealData.name
                                                  }
                                                />
                                              );
                                            }}
                                          />
                                        )}
                                    </FormControl>
                                    <p className="errorMessage mb-2">
                                      {errors.agent?.message}
                                    </p>
                                  </div>

                                  {watch("interest") === "rent" && (
                                    <div className="col-4">
                                      <label className="myLbl">
                                        Payment Cycle{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <FormControl
                                        fullWidth
                                        className="whiteBackground"
                                      >
                                        <Select
                                          labelId="paymentCycle"
                                          id="demo-simple-select"
                                          size="small"
                                          style={{ fontSize: "14px" }}
                                          name="paymentCycle"
                                          value={
                                            watch("paymentCycle") ||
                                            (DealData && DealData.paymentCycle)
                                          }
                                          {...register("paymentCycle", {
                                            required: true,
                                          })}
                                        >
                                          <MenuItem value={1}>1</MenuItem>
                                          <MenuItem value={2}>2</MenuItem>
                                          <MenuItem value={3}>3</MenuItem>
                                          <MenuItem value={4}>4</MenuItem>
                                          <MenuItem value={5}>5</MenuItem>
                                          <MenuItem value={6}>6</MenuItem>
                                          <MenuItem value={7}>7</MenuItem>
                                          <MenuItem value={8}>8</MenuItem>
                                          <MenuItem value={9}>9</MenuItem>
                                          <MenuItem value={10}>10</MenuItem>
                                          <MenuItem value={11}>11</MenuItem>
                                          <MenuItem value={12}>12</MenuItem>
                                          <MenuItem value={13}>13</MenuItem>
                                          <MenuItem value={14}>14</MenuItem>
                                          <MenuItem value={15}>15</MenuItem>
                                          <MenuItem value={16}>16</MenuItem>
                                          <MenuItem value={17}>17</MenuItem>
                                          <MenuItem value={18}>18</MenuItem>
                                          <MenuItem value={19}>19</MenuItem>
                                          <MenuItem value={20}>20</MenuItem>
                                          <MenuItem value={21}>21</MenuItem>
                                          <MenuItem value={22}>22</MenuItem>
                                          <MenuItem value={23}>23</MenuItem>
                                          <MenuItem value={24}>24</MenuItem>
                                          <MenuItem value={25}>25</MenuItem>
                                          <MenuItem value={26}>26</MenuItem>
                                          <MenuItem value={27}>27</MenuItem>
                                          <MenuItem value={28}>28</MenuItem>
                                        </Select>
                                      </FormControl>
                                      <p className="errorMessage mb-2">
                                        {errors.paymentCycle?.message}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </FormControl>
                            </div>

                            {DealData && DealData.comments.length > 0 && (
                              <div className="form-group form-group col-12">
                                <label className="myLbl">Date</label>
                                <div className="form-group col-12 commentsDivStyle py-2">
                                  <div>
                                    {DealData.comments.map((comments) => (
                                      <div className="mb-0">
                                        <p className="mb-0">{comments}</p>
                                        <p className="mb-0">
                                          {new Date(
                                            DealData.createdAt.toDate()
                                          ).toLocaleString()}
                                        </p>
                                        <hr />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="form-group col-12">
                              <label className="myLbl">Comments</label>
                              <FormControl fullWidth>
                                <TextField
                                  inputProps={{
                                    style: {
                                      textTransform: "capitalize",
                                    },
                                  }}
                                  id="outlined-basic"
                                  name="comments"
                                  onChange={(e) => {
                                    setArea(e.target.value);
                                  }}
                                  variant="outlined"
                                  className="lightYellowBackground"
                                  multiline
                                  style={{ width: "100%" }}
                                  rows={10}
                                  disabled={isDisabled}
                                />
                              </FormControl>
                            </div>

                            <div className="form-group col-12">
                              <div className="row">
                                <div className="col-lg-12 mb-4">
                                  <div className="default-tab">
                                    <ul className="nav nav-tabs" role="tablist">
                                      <li
                                        className="nav-item"
                                        onClick={() => {
                                          setTransactionTab(true);
                                          setLogVisitsTab(false);
                                          setFilesTab(false);
                                        }}
                                      >
                                        <a
                                          className={`nav-link ${
                                            TransactionTab ? "active " : ""
                                          }`}
                                          // data-toggle="tab"
                                          href="#transaction"
                                        >
                                          Transaction
                                        </a>
                                      </li>
                                      <li
                                        className="nav-item"
                                        onClick={() => {
                                          setLogVisitsTab(true);
                                          setTransactionTab(false);
                                          setFilesTab(false);
                                        }}
                                      >
                                        <a
                                          className={`nav-link ${
                                            LogVisitsTab ? "active " : ""
                                          }`}
                                          // data-toggle="tab"
                                          href="#visits"
                                        >
                                          Log Visitor
                                        </a>
                                      </li>

                                      <li
                                        className="nav-item"
                                        onClick={() => {
                                          setFilesTab(true);
                                          setTransactionTab(false);
                                          setLogVisitsTab(false);
                                        }}
                                      >
                                        <a
                                          className={`nav-link ${
                                            FilesTab ? "active " : ""
                                          }`}
                                          // data-toggle="tab"
                                          href="#files"
                                        >
                                          Files
                                        </a>
                                      </li>
                                    </ul>
                                    <div className="tab-content p-3 bg-white">
                                      {TransactionTab && (
                                        <div
                                          // className="tab-pane fade show active"
                                          id="transaction"
                                        >
                                          <div className="row pt-3 mb-1">
                                            <div className="col-12">
                                              {!FormVisible && (
                                                <Fragment>
                                                  <button
                                                    onClick={toggleFormVisible}
                                                    type="submit"
                                                    className="btn btn-primary editBtnStyle float-right mb-3"
                                                  >
                                                    <i className="fa fa-solid fa-pencil"></i>{" "}
                                                    + New Transaction
                                                  </button>
                                                  <List
                                                    sx={{
                                                      width: "100%",
                                                      maxWidth: "100%",
                                                      bgcolor:
                                                        "background.paper",
                                                      position: "relative",
                                                      overflow: "auto",
                                                      maxHeight: 300,
                                                      "& ul": {
                                                        padding: 0,
                                                      },
                                                    }}
                                                    subheader={<li />}
                                                  >
                                                    {Transactions.map(
                                                      (t, index) => {
                                                        setValue(
                                                          `transactions.${index}`,
                                                          t
                                                        );
                                                        return (
                                                          <TransactionList
                                                            {...{
                                                              ...t,
                                                              setFormForUpdate:
                                                                () =>
                                                                  setFormForUpdate(
                                                                    index
                                                                  ),
                                                              removeTransaction:
                                                                () =>
                                                                  removeTransaction(
                                                                    index
                                                                  ),
                                                            }}
                                                          />
                                                        );
                                                      }
                                                    )}
                                                    {Transactions.length ===
                                                      0 && (
                                                      <div className="custom-nothing"></div>
                                                    )}
                                                  </List>
                                                </Fragment>
                                              )}
                                              {FormVisible && (
                                                <Fragment>
                                                  <form>
                                                    <Fragment>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <div>
                                                          <label className="myLbl">
                                                            Amount{" "}
                                                            <span
                                                              style={{
                                                                color: "red",
                                                              }}
                                                            >
                                                              *
                                                            </span>
                                                          </label>
                                                          <br></br>

                                                          {/* Amount */}
                                                          <TextField
                                                            name={"amount"}
                                                            id="amountField"
                                                            value={Amount}
                                                            required
                                                            type={"number"}
                                                            className={
                                                              "bg-white mb-1"
                                                            }
                                                            onChange={(e) => {
                                                              e.target.value > 0
                                                                ? setAmount(
                                                                    e.target
                                                                      .value
                                                                  )
                                                                : setAmount("");
                                                            }}
                                                          />
                                                        </div>
                                                        <div
                                                          style={{
                                                            margin:
                                                              "30px 0px 0px 35px",
                                                          }}
                                                        >
                                                          <p
                                                            style={{
                                                              color:
                                                                "#4B4B4BE5",
                                                            }}
                                                          >
                                                            {Amount > 0 && (
                                                              <span>
                                                                {
                                                                  CurrencySettings.currency
                                                                }
                                                                {`
                                                                ${
                                                                  Amount &&
                                                                  Amount > 0
                                                                    ? FormatPriceVerbal(
                                                                        Amount
                                                                      )
                                                                    : ""
                                                                }
                                                              `}
                                                              </span>
                                                            )}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </Fragment>

                                                    {/* Comments */}
                                                    <FormControl fullWidth>
                                                      <label className="myLbl">
                                                        Comments{" "}
                                                      </label>
                                                      <TextField
                                                        inputProps={{
                                                          style: {
                                                            textTransform:
                                                              "capitalize",
                                                          },
                                                        }}
                                                        id="outlined-basic"
                                                        className="lightYellowBackground"
                                                        name="comments"
                                                        value={Comments}
                                                        onChange={(e) => {
                                                          setComments(
                                                            e.target.value
                                                          );
                                                        }}
                                                        variant="outlined"
                                                        multiline
                                                        rows={5}
                                                        disabled={isDisabled}
                                                      />
                                                    </FormControl>

                                                    <Box className="mt-2">
                                                      <FormControl fullWidth>
                                                        <label className="myLbl">
                                                          Payment Type{" "}
                                                          <span
                                                            style={{
                                                              color: "red",
                                                            }}
                                                          >
                                                            *
                                                          </span>
                                                        </label>
                                                        <Select
                                                          labelId="demo-simple-select-label"
                                                          id="typeField"
                                                          value={PaymentType}
                                                          required
                                                          onChange={(e) =>
                                                            setPaymentType(
                                                              e.target.value
                                                            )
                                                          }
                                                        >
                                                          <MenuItem
                                                            value={"cash"}
                                                          >
                                                            Cash
                                                          </MenuItem>
                                                          <MenuItem
                                                            value={"online"}
                                                          >
                                                            Online Transaction
                                                          </MenuItem>
                                                        </Select>
                                                      </FormControl>
                                                    </Box>
                                                    <input
                                                      type={"submit"}
                                                      id="hiddenSubmitButton"
                                                      style={{ opacity: 0 }}
                                                    />
                                                    <button
                                                      onClick={() => {
                                                        if (
                                                          Amount === "" ||
                                                          PaymentType === ""
                                                        )
                                                          document
                                                            .getElementById(
                                                              "hiddenSubmitButton"
                                                            )
                                                            .click();
                                                        else
                                                          TransactionToEditIndex ===
                                                          null
                                                            ? addTransaction()
                                                            : updateTransaction();
                                                      }}
                                                      type={"button"}
                                                      className="btn btn-primary mt-3 float-lg-right float-md-right float-sm-right mr-2"
                                                    >
                                                      {TransactionToEditIndex ===
                                                      null
                                                        ? "ADD"
                                                        : "Update"}
                                                    </button>
                                                    <button
                                                      onClick={
                                                        closeTransactionForm
                                                      }
                                                      className="btn btn-primary mt-3 float-lg-right float-md-right float-sm-right mr-2"
                                                    >
                                                      Cancel
                                                    </button>
                                                  </form>
                                                </Fragment>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {LogVisitsTab && (
                                        <div
                                          // className="tab-pane fade"
                                          id="visits"
                                          role="tabpanel"
                                        >
                                          <div className="row pt-3 mb-1">
                                            <div className="col-12">
                                              <div className="pt-4">
                                                <div className="d-flex">
                                                  <div className="col-12">
                                                    {leads && (
                                                      <div
                                                        onClick={() => {
                                                          setLogVisitorModal(
                                                            true
                                                          );
                                                        }}
                                                        // href="#"
                                                        className="btn btn-xs btn-primary mb-4 f-r"
                                                        // data-toggle="modal"
                                                        // data-target=".bd-example-modal-lg"
                                                      >
                                                        <i className="fa fa-plus"></i>{" "}
                                                        Add Visitor
                                                      </div>
                                                    )}
                                                  </div>

                                                  {/* <!-- Add Log Visitor Popup --> */}
                                                  <Modal
                                                    open={
                                                      LogVisitorModal
                                                        ? true
                                                        : false
                                                    }
                                                    onClose={() => {
                                                      setLogVisitorModal(false);
                                                    }}
                                                    aria-labelledby="modal-modal-title"
                                                    aria-describedby="modal-modal-description"
                                                    className="modal-style"
                                                  >
                                                    <div className="modal-dialog modal-lg">
                                                      <div className="log-visits-modal-content-container modal-content">
                                                        <div className="modal-header">
                                                          <h3 className="modal-title">
                                                            Add Log Visitor
                                                          </h3>
                                                          <button
                                                            type="button"
                                                            className="close"
                                                            onClick={() => {
                                                              setLogVisitorModal(
                                                                false
                                                              );
                                                            }}
                                                          >
                                                            <span>&times;</span>
                                                          </button>
                                                        </div>
                                                        <form
                                                          style={{
                                                            border: "none",
                                                          }}
                                                          className=""
                                                        >
                                                          <div className="log-visits-modal-content modal-body">
                                                            <div className="form-row">
                                                              <div className="form-group col-6">
                                                                <label className="myLbl">
                                                                  Client
                                                                </label>
                                                                <FormControl
                                                                  fullWidth
                                                                >
                                                                  {leads &&
                                                                    watch(
                                                                      "lead"
                                                                    ) !==
                                                                      undefined && (
                                                                      <Autocomplete
                                                                        id="tags-outlined"
                                                                        options={
                                                                          leads
                                                                        }
                                                                        Agent
                                                                        value={
                                                                          lead
                                                                            ? lead
                                                                            : leads
                                                                                .filter(
                                                                                  (
                                                                                    a
                                                                                  ) =>
                                                                                    a.id ===
                                                                                    watch(
                                                                                      "lead"
                                                                                    )
                                                                                )
                                                                                .pop()
                                                                        }
                                                                        onChange={(
                                                                          event,
                                                                          value
                                                                        ) =>
                                                                          setLead(
                                                                            value
                                                                          )
                                                                        }
                                                                        getOptionLabel={(
                                                                          option
                                                                        ) =>
                                                                          option.name
                                                                        }
                                                                        renderOption={(
                                                                          props,
                                                                          option
                                                                        ) => (
                                                                          <MenuItem
                                                                            {...props}
                                                                            id={
                                                                              option.id
                                                                            }
                                                                          >
                                                                            {
                                                                              <Card
                                                                                sx={{
                                                                                  display:
                                                                                    "flex",
                                                                                }}
                                                                                style={{
                                                                                  width:
                                                                                    "100%",
                                                                                }}
                                                                                elevation={
                                                                                  0
                                                                                }
                                                                                className="agentInputCard"
                                                                              >
                                                                                <Avatar
                                                                                  className="ml-1 mt-1 agentInputAvatar"
                                                                                  {...stringAvatar(
                                                                                    option.name
                                                                                  )}
                                                                                />

                                                                                <Typography
                                                                                  component="div"
                                                                                  variant="p"
                                                                                  className="agentInputName"
                                                                                >
                                                                                  {
                                                                                    option.name
                                                                                  }
                                                                                </Typography>
                                                                              </Card>
                                                                            }
                                                                          </MenuItem>
                                                                        )}
                                                                        renderInput={(
                                                                          params
                                                                        ) => {
                                                                          return (
                                                                            <TextField
                                                                              {...params}
                                                                              size="small"
                                                                              placeholder="Search Client"
                                                                              value={
                                                                                DealData &&
                                                                                DealData.name
                                                                              }
                                                                            />
                                                                          );
                                                                        }}
                                                                      />
                                                                    )}
                                                                </FormControl>
                                                                <p>
                                                                  {LeadError}
                                                                </p>
                                                              </div>

                                                              <div className="form-group col-6">
                                                                <label className="myLbl">
                                                                  Status
                                                                </label>
                                                                <FormControl
                                                                  fullWidth
                                                                >
                                                                  <Select
                                                                    id="typeField"
                                                                    name="status"
                                                                    value={
                                                                      status
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      setStatus(
                                                                        e.target
                                                                          .value
                                                                      )
                                                                    }
                                                                    disabled={
                                                                      isDisabled
                                                                    }
                                                                  >
                                                                    <MenuItem
                                                                      value={
                                                                        "interested"
                                                                      }
                                                                    >
                                                                      Interested
                                                                    </MenuItem>
                                                                    <MenuItem
                                                                      value={
                                                                        "not-interested"
                                                                      }
                                                                    >
                                                                      Not
                                                                      Interested
                                                                    </MenuItem>
                                                                  </Select>
                                                                </FormControl>
                                                                <p>
                                                                  {StatusError}
                                                                </p>
                                                              </div>
                                                            </div>

                                                            <div className="form-row">
                                                              <div className="form-group col-12">
                                                                <label className="myLbl">
                                                                  Date
                                                                </label>
                                                                <LocalizationProvider
                                                                  dateAdapter={
                                                                    AdapterDateFns
                                                                  }
                                                                  id="typeField"
                                                                >
                                                                  <DateTimePicker
                                                                    id="typeField"
                                                                    value={
                                                                      visitorDateTime
                                                                    }
                                                                    onChange={(
                                                                      val
                                                                    ) =>
                                                                      setVisitorDateTime(
                                                                        val
                                                                      )
                                                                    }
                                                                    disabled={
                                                                      isDisabled
                                                                    }
                                                                    renderInput={(
                                                                      params
                                                                    ) => (
                                                                      <TextField
                                                                        {...params}
                                                                        id="typeField"
                                                                        style={{
                                                                          width:
                                                                            "100%",
                                                                        }}
                                                                      />
                                                                    )}
                                                                  />
                                                                </LocalizationProvider>
                                                              </div>
                                                              <p>
                                                                {DateTimeError}
                                                              </p>
                                                            </div>

                                                            <div className="form-row">
                                                              <label
                                                                className="myLbl"
                                                                id="descr-lbl"
                                                              >
                                                                Description
                                                              </label>
                                                              <div
                                                                className="form-group col-12 p-0"
                                                                id="descr-body"
                                                              >
                                                                <TextField
                                                                  inputProps={{
                                                                    style: {
                                                                      textTransform:
                                                                        "capitalize",
                                                                    },
                                                                  }}
                                                                  id="typeField"
                                                                  name="description"
                                                                  value={
                                                                    description
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    setDescription(
                                                                      e.target
                                                                        .value
                                                                    );
                                                                  }}
                                                                  variant="outlined"
                                                                  multiline
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                  }}
                                                                  rows={10}
                                                                  disabled={
                                                                    isDisabled
                                                                  }
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className="modal-footer">
                                                            <button
                                                              type="button"
                                                              className="mr-3 btn btn-outline-danger light"
                                                              // data-dismiss="modal"
                                                              onClick={() => {
                                                                setLogVisitorModal(
                                                                  false
                                                                );
                                                              }}
                                                            >
                                                              Cancel
                                                            </button>
                                                            <button
                                                              onClick={
                                                                submitVisitsForm
                                                              }
                                                              className="btn btn-primary"
                                                            >
                                                              {isDisabled && (
                                                                <span className="spinner-border spinner-border-sm mr-1"></span>
                                                              )}
                                                              Add
                                                            </button>
                                                          </div>
                                                        </form>
                                                      </div>
                                                    </div>
                                                  </Modal>
                                                </div>

                                                <div className="visitorContainer">
                                                  {logVisitors &&
                                                    logVisitors.map(
                                                      (logVisit) => (
                                                        <div className="form-row logVisitorContainer">
                                                          <div className="col-6 leadStatus">
                                                            <p className="logVisitorLead">
                                                              {
                                                                logVisit?.leadName
                                                              }
                                                            </p>
                                                            <p className="logVisitorStatus">
                                                              {logVisit?.status}
                                                            </p>
                                                          </div>

                                                          <div className="col-6 addedDateDescription">
                                                            <p className="logVisitorAddedDate">
                                                              {new Date(
                                                                logVisit?.dateTime.toDate()
                                                              ).toLocaleString()}
                                                            </p>

                                                            <p className="logVisitorDescription">
                                                              {
                                                                logVisit?.description
                                                              }
                                                            </p>
                                                          </div>
                                                        </div>
                                                      )
                                                    )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {FilesTab && (
                                        <div
                                          // className="tab-pane fade"
                                          id="files"
                                          role="tabpanel"
                                        >
                                          <div className="row pt-3 mb-3">
                                            <div className="col-12 mb-4">
                                              <List
                                                dense={false}
                                                className="d-flex flex-wrap justify-content-around row"
                                              >
                                                {ServerFiles.map(
                                                  ({
                                                    contentType,
                                                    name,
                                                    url,
                                                    timeCreated,
                                                  }) => {
                                                    return (
                                                      <div className="col-6">
                                                        <ListItem
                                                          className="border border-1 border-light-50 rounded mb-2 col"
                                                          secondaryAction={
                                                            <Fragment>
                                                              <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                className="mr-1"
                                                                onClick={() =>
                                                                  downloadFile(
                                                                    url
                                                                  )
                                                                }
                                                              >
                                                                <DownloadIcon />
                                                              </IconButton>
                                                              <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                className="mr-1"
                                                              >
                                                                <DeleteIcon />
                                                              </IconButton>
                                                            </Fragment>
                                                          }
                                                        >
                                                          <ListItemAvatar>
                                                            <Avatar>
                                                              <FileIcon />
                                                            </Avatar>
                                                          </ListItemAvatar>
                                                          <ListItemText
                                                            primary={name}
                                                            secondary={
                                                              <span className="fs-12 text-light">
                                                                {contentType}
                                                              </span>
                                                            }
                                                          />
                                                        </ListItem>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              </List>
                                            </div>
                                            <div className="col-12 mb-4 text-center">
                                              {IsGettingUploadedFiles && (
                                                <div
                                                  className="spinner-border my-5"
                                                  role="status"
                                                ></div>
                                              )}
                                              <Dropzone
                                                onChange={updateFiles}
                                                value={files}
                                                onClean={handleClean}
                                                maxFiles={20}
                                                maxFileSize={2998000}
                                                accept=".png,image/*"
                                                uploadingMessage={
                                                  "Uploading..."
                                                }
                                                url="gs://property-management-port-12157.appspot.com/deals/asdasdasdasd"
                                                fakeUploading
                                                disableScroll
                                              >
                                                {files.map((file) => (
                                                  <FileItem
                                                    {...file}
                                                    preview
                                                    onDelete={onDelete}
                                                    onSee={handleSee}
                                                    resultOnTooltip
                                                    info
                                                    hd
                                                  />
                                                ))}

                                                <FullScreenPreview
                                                  imgSource={imageSrc}
                                                  openImage={imageSrc}
                                                  onClose={(e) =>
                                                    handleSee(undefined)
                                                  }
                                                />
                                              </Dropzone>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="modal-footer modalFooterFixed">
                              <button
                                onClick={() => Navigate("/user/deals")}
                                className="mr-3 btn btn-outline-danger light btn-md btn-rounded"
                                data-dismiss="modal"
                              >
                                Cancel
                              </button>

                              <button
                                type="submit"
                                className="btn btn-primary btn-md btn-rounded"
                                disabled={isDisabled}
                              >
                                {" "}
                                {isDisabled && (
                                  <span className="spinner-border spinner-border-sm mr-1"></span>
                                )}
                                Update
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            </form>
          </div>
        </div>
      </div>
      <LeadForm
        {...{
          open,
          setOpen,
          handleRefresh,
        }}
      />
      <ToastContainer />
    </Fragment>
  );
};

export default UpdateDeal;
